import { Select } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@/store/appStore';

export function JahrSwitcher() {
  const { t } = useTranslation('common');
  const jahr = useAppStore((s) => s.activeFoerderjahr);
  const setJahr = useAppStore((s) => s.setFoerderjahr);

  const options = useMemo(() => {
    const current = new Date().getFullYear();
    const years: { value: string; label: string }[] = [];
    for (let y = current - 3; y <= current + 2; y += 1) {
      years.push({ value: String(y), label: String(y) });
    }
    return years;
  }, []);

  return (
    <Select
      label={t('header.foerderjahr')}
      data={options}
      value={String(jahr)}
      onChange={(v) => v && setJahr(Number(v))}
      w={130}
      aria-label={t('header.foerderjahr')}
    />
  );
}
